import { createAction, props } from '@ngrx/store';
import { IAuthCustomer } from '../../../core/models/auth.model';

export const requestLoginCode = createAction(
  '[Auth] Request Login Code',
  props<{ phone: string; resend: boolean; channel: string; token?: string }>()
);

export const successRequestLoginCode = createAction(
  '[Auth] Success Request Login Code',
  props<{ customer: IAuthCustomer }>()
);

export const failureRequestLoginCode = createAction(
  '[Auth] Failure Request Login Code',
  props<{ message: string }>()
);

export const updateCountTimmerOTP = createAction(
  '[Auth] Update Count Timmer OTP',
  props<{ countErrorOTP: number }>()
);

export const setCaptcha = createAction(
  '[Auth] Set Captcha',
  props<{ token: string; channel?: string }>()
);

export const setCurrentTime = createAction(
  '[Auth] Set Current Time',
  props<{ currentTime: number }>()
);
